import { useEffect } from "react";
import { useLocation, Outlet, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import { restaurantConfig } from "../config/restaurantConfig";

export default function Layout() {
  const { pathname } = useLocation();

  // Always scroll to top on route change
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" }); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <motion.main
        key={pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="flex-1 pt-20"
      >
        <Outlet />
      </motion.main>
      <Footer />

      {/* Floating reservation CTA (mobile-friendly) */}
      {pathname !== "/reservation" && (
        <Link
          to="/reservation"
          data-testid="floating-reserve-cta"
          className="md:hidden fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-5 py-3 bg-burgundy text-white text-[11px] tracking-luxe uppercase shadow-2xl shadow-burgundy/30"
        >
          <Phone className="w-3.5 h-3.5" strokeWidth={2} />
          {restaurantConfig.ui.reserveButton}
        </Link>
      )}

      {/* Floating phone CTA on desktop */}
      {pathname !== "/reservation" && (
        <a
          href={restaurantConfig.contact.phoneLink}
          data-testid="floating-phone-cta"
          className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-3 px-5 py-3 bg-background border border-accent-line text-accent-line text-[11px] tracking-luxe uppercase hover:bg-burgundy hover:text-white dark:hover:bg-gold dark:hover:text-zinc-950 hover:border-transparent transition-colors"
        >
          <Phone className="w-3.5 h-3.5" strokeWidth={2} />
          {restaurantConfig.contact.phoneDisplay}
        </a>
      )}
    </div>
  );
}
